import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { COMPONENTS } from '../../../../../routers/constants'

export const HeaderLatestReports = () => {
  const navigate = useNavigate()

  //Actions
  const navigateDashboard = () => {
    navigate(COMPONENTS.dashboard.components.dashboard.route)
  }

  return (
    <>
      <div>
        <Element
          className="wFitContent cursorPointer"
          style={{
            lineHeight: '16px',
            border: 'solid 1px #D5D5D5',
            borderRadius: 4,
            padding: '5px 8px',
          }}
          onClick={navigateDashboard}
        >
          <Icon
            className="icon-arrow-left"
            style={{ fontSize: 8, padding: '0 4px' }}
          />
          <Translate value="dashboard.latestReport.backDashboard" />
        </Element>
      </div>
      <div>
        <Element
          elementName="p"
          className="fw500"
          style={{
            color: '#191D25',
            fontSize: 20,
            lineHeight: '24px',
            paddingTop: 12,
            paddingBottom: 16,
          }}
        >
          <Translate value="dashboard.latestReport.latestReport" />
        </Element>
      </div>
    </>
  )
}
